// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2sxnx","alert":"SettungsInbox_alert__2iErx"};